import React, { useContext } from "react";

import ImageCopyright from "@/components/ImageCopyright/ImageCopyright";
import { Overlay } from "@/components/Overlay";
import { GlobalContext } from "@/contexts";
import LocaleContext from "@/i18n";
import { ImageData } from "@/service/Model";

import { ImageCopyrightWrapper, Scroll } from "./styles";

export type CopyrightOverlayProps = {
  onClose: () => void;
  imagesData: ImageData[];
};

const CopyrightOverlay: React.FC<CopyrightOverlayProps> = (
  props: CopyrightOverlayProps
): JSX.Element => {
  const { onClose, imagesData } = props;
  const globalContext = useContext(GlobalContext);
  const localeContext = useContext(LocaleContext);
  const { translation } = localeContext;

  return (
    <Overlay
      icons={globalContext.icons}
      dismiss={true}
      showCloseButton={true}
      onClose={onClose}
    >
      <ImageCopyrightWrapper>
        <h2>{translation.imageCopyright}</h2>
        <Scroll>
          {imagesData.map((imageData: ImageData, index: number) => (
            <ImageCopyright
              sourceLabel={translation.source}
              imageData={imageData}
              key={`ìmage-${index}`}
            />
          ))}
        </Scroll>
      </ImageCopyrightWrapper>
    </Overlay>
  );
};

export default CopyrightOverlay;
